import {Button, Icon, Header, Segment, Transition} from "semantic-ui-react";
import React, {Component} from "react";
import {Input, Dropdown, Form, Modal, Container} from 'semantic-ui-react'
import Countdown from 'react-countdown';
import { isMobile } from 'react-device-detect';

// Add CSS styles for ripple effect
const rainbowStyles = `
  @keyframes ripple {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(2.5);
      opacity: 0;
    }
  }
  
  @keyframes button-pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
  
  @keyframes shimmer {
    0% {
      left: -200px;
    }
    100% {
      left: calc(100% + 200px);
    }
  }
  
  #action-message-button {
    position: relative !important;
    overflow: hidden !important;
    width: 300px !important;
    min-width: 300px !important;
  }
  
  #action-message-button:hover {
    animation: button-pulse 1s ease-in-out infinite !important;
    box-shadow: 0 0 20px rgba(75, 184, 19, 0.6) !important;
    transition: all 0.3s ease !important;
  }
  
  #action-message-button:hover::before {
    content: '' !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    width: 100% !important;
    height: 100% !important;
    background: radial-gradient(circle, rgba(75, 184, 19, 0.3) 0%, rgba(75, 184, 19, 0.1) 50%, transparent 70%) !important;
    border-radius: 50% !important;
    transform: translate(-50%, -50%) scale(1) !important;
    animation: ripple 2s ease-out infinite !important;
    pointer-events: none !important;
    z-index: -1 !important;
    will-change: transform, opacity !important;
    contain: layout !important;
  }
  
  #action-message-button.rainbow-button:hover::before {
    background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.2) 50%, transparent 70%) !important;
  }
  
  #action-message-button.shimmer-effect::after {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    left: -200px !important;
    width: 200px !important;
    height: 100% !important;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent) !important;
    animation: shimmer 1.5s ease-in-out !important;
    pointer-events: none !important;
    z-index: 1 !important;
  }
  
  #action-message-button.shimmer-effect.rainbow-button::after {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    left: -200px !important;
    width: 200px !important;
    height: 100% !important;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent) !important;
    animation: shimmer 1.5s ease-in-out !important;
    pointer-events: none !important;
    z-index: 1 !important;
  }
`;

// Inject styles into document head
if (typeof document !== 'undefined') {
  // Check if styles are already injected
  if (!document.getElementById('rainbow-border-styles')) {
    const styleSheet = document.createElement("style");
    styleSheet.id = 'rainbow-border-styles';
    styleSheet.type = "text/css";
    styleSheet.innerText = rainbowStyles;
    document.head.appendChild(styleSheet);
    console.log('Rainbow border hover styles injected');
  }
}


// Renderer callback with condition
const format = (n) => {
    return n > 9 ? n : `0${n}`;
}
const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
        // Render a completed state
        return <div />;
    } else {
        // Render a countdown
        return (
            <>
            <div style={{marginBottom: 3}}>
                <span style={{color: 'dodgerblue', fontWeight: 'bold'}}>%50</span> discount coupon!
            </div>
            <div style={{marginBottom: 3}}>
                Coupon:
            </div>
            <div style={{marginBottom: 3}}>
                <Header as='h3' style={{color: '#f3701d'}}>
                    QQEMA
                </Header>
            </div>
            <div style={{marginBottom: 3}}>
                Offer ends at:
            </div>
            <div style={{marginBottom: 0}}>

                <Header as='h3' style={{color: '#f3701d' }}>
                    {format(days)} : {format(hours)} : {format(minutes)} : {format(seconds)}
                </Header>

            </div>
            <div>
                <h6 style={{marginTop: 0}}>
                <span style={{paddingLeft: 2}}>DYS</span>
                <span style={{paddingLeft: 15}}>HRS</span>
                <span style={{paddingLeft: 14}}>MIN</span>
                <span style={{paddingLeft: 15}}>SEC</span>
                </h6>
            </div>
            </>

        )
    }
};

export default class ActionMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: true,
            isShaking: false,
            rainbowFrame: 0,
            isShimmering: false
        };
        this.rainbowInterval = null;
        this.shimmerInterval = null;
        this.rainbowColors = [
            '#ff0000', '#ff4000', '#ff8000', '#ffbf00', '#ffff00', 
            '#bfff00', '#80ff00', '#40ff00', '#00ff00', '#00ff40',
            '#00ff80', '#00ffbf', '#00ffff', '#00bfff', '#0080ff', 
            '#0040ff', '#0000ff', '#4000ff', '#8000ff', '#bf00ff',
            '#ff00ff', '#ff00bf', '#ff0080', '#ff0040'
        ];
    }

    startRainbowAnimation() {
        if (this.rainbowInterval) {
            clearInterval(this.rainbowInterval);
        }
        
        this.rainbowInterval = setInterval(() => {
            this.setState(prevState => ({
                rainbowFrame: (prevState.rainbowFrame + 1) % this.rainbowColors.length
            }));
        }, 80); // Change color every 80ms for smoother, calmer animation
    }

    stopRainbowAnimation() {
        if (this.rainbowInterval) {
            clearInterval(this.rainbowInterval);
            this.rainbowInterval = null;
        }
        this.setState({ rainbowFrame: 0 });
    }


    startShimmerInterval() {
        // Start shimmer effect every 10 seconds
        this.shimmerInterval = setInterval(() => {
            if (!this.state.isShaking) { // Only shimmer if not currently shaking
                this.setState({ isShimmering: true });
                // Stop shimmer after animation completes
                setTimeout(() => {
                    this.setState({ isShimmering: false });
                }, 1500);
            }
        }, 10000);
    }

    stopShimmerInterval() {
        if (this.shimmerInterval) {
            clearInterval(this.shimmerInterval);
            this.shimmerInterval = null;
        }
        this.setState({ isShimmering: false });
    }

    componentDidMount() {
        this.startShimmerInterval();
    }

    componentWillUnmount() {
        this.stopRainbowAnimation();
        this.stopShimmerInterval();
    }

    render(){
        const { cta } = this.props;
        const messageBody = cta?.message?.body;
        const marginLeft = isMobile ? 8 : 150;

        // Localization data for all supported languages
    const translations = {
        en: {
            upgradeExperience: 'Upgrade Your Experience',
            premiumBenefits: 'Benefits',
            unlimitedLabTime: 'Unlimited Lab Time',
            noTimeRestrictions: 'No time restrictions',
            saveUnlimitedCircuits: 'Save your experiments',
            neverLoseWork: 'Never lose your work',
            allComponents: '40+ Components',
            fullComponentLibrary: 'Real-looking parts',
            prioritySupport: 'Priority Support',
            helpWhenNeeded: 'Help when you need it',
            testimonial: 'It\'s enjoyable to interact with. The user interface gives me the sensation of operating a real Relay unit in a laboratory.',
            testimonialAuthor: 'Hobbyist in Queensland',
            continueWithLimited: 'Continue with Limited Access',
            upgradeNow: 'Start with {cheapest_plan}!',
            schoolLicenseMessage: 'We kindly ask students to check with their teachers about obtaining a school license to continue using DCACLab.'
        },
        ar: {
            upgradeExperience: 'ترقية تجربتك',
            premiumBenefits: 'مزايا',
            unlimitedLabTime: 'وقت مختبر غير محدود',
            noTimeRestrictions: 'لا قيود زمنية',
            saveUnlimitedCircuits: 'احفظ تجاربك',
            neverLoseWork: 'لن تفقد عملك أبدًا',
            allComponents: '40+ مكونات',
            fullComponentLibrary: 'قطع ذات مظهر حقيقي',
            prioritySupport: 'دعم ذو أولوية',
            helpWhenNeeded: 'المساعدة عند الحاجة',
            testimonial: 'من الممتع التفاعل معه. واجهة المستخدم تعطيني إحساس بتشغيل وحدة مرحل حقيقية في المختبر.',
            testimonialAuthor: 'هاوٍ في كوينزلاند',
            continueWithLimited: 'المتابعة بوصول محدود',
            upgradeNow: 'ابدأ مع {cheapest_plan}!',
            schoolLicenseMessage: 'نطلب بلطف من الطلاب التحقق مع معلميهم بشأن الحصول على ترخيص مدرسي لمواصلة استخدام DCACLab.'
        },
        de: {
            upgradeExperience: 'Verbessern Sie Ihr Erlebnis',
            premiumBenefits: 'Vorteile',
            unlimitedLabTime: 'Unbegrenzte Laborzeit',
            noTimeRestrictions: 'Keine Zeitbeschränkungen',
            saveUnlimitedCircuits: 'Speichern Sie Ihre Experimente',
            neverLoseWork: 'Verlieren Sie nie Ihre Arbeit',
            allComponents: '40+ Komponenten',
            fullComponentLibrary: 'Realistisch aussehende Teile',
            prioritySupport: 'Prioritäts-Support',
            helpWhenNeeded: 'Hilfe, wenn Sie sie brauchen',
            testimonial: 'Es macht Spaß, damit zu interagieren. Die Benutzeroberfläche gibt mir das Gefühl, ein echtes Relais in einem Labor zu bedienen.',
            testimonialAuthor: 'Hobbyist in Queensland',
            continueWithLimited: 'Mit eingeschränktem Zugriff fortfahren',
            upgradeNow: 'Starten Sie mit {cheapest_plan}!',
            schoolLicenseMessage: 'Wir bitten Schüler höflich, mit ihren Lehrern über den Erwerb einer Schullizenz zu sprechen, um DCACLab weiterhin nutzen zu können.'
        },
        fr: {
            upgradeExperience: 'Améliorez Votre Expérience',
            premiumBenefits: 'Avantages',
            unlimitedLabTime: 'Temps de Laboratoire Illimité',
            noTimeRestrictions: 'Pas de restrictions de temps',
            saveUnlimitedCircuits: 'Sauvegardez vos expériences',
            neverLoseWork: 'Ne perdez jamais votre travail',
            allComponents: '40+ Composants',
            fullComponentLibrary: 'Pièces d\'apparence réaliste',
            prioritySupport: 'Support Prioritaire',
            helpWhenNeeded: 'De l\'aide quand vous en avez besoin',
            testimonial: 'C\'est agréable d\'interagir avec. L\'interface utilisateur me donne la sensation de faire fonctionner une unité de relais réelle dans un laboratoire.',
            testimonialAuthor: 'Passionné au Queensland',
            continueWithLimited: 'Continuer avec un Accès Limité',
            upgradeNow: 'Commencez avec {cheapest_plan}!',
            schoolLicenseMessage: 'Nous demandons gentiment aux étudiants de se renseigner auprès de leurs enseignants concernant l\'obtention d\'une licence scolaire pour continuer à utiliser DCACLab.'
        },
        es: {
            upgradeExperience: 'Mejora Tu Experiencia',
            premiumBenefits: 'Beneficios',
            unlimitedLabTime: 'Tiempo de Laboratorio Ilimitado',
            noTimeRestrictions: 'Sin restricciones de tiempo',
            saveUnlimitedCircuits: 'Guarda tus experimentos',
            neverLoseWork: 'Nunca pierdas tu trabajo',
            allComponents: '40+ Componentes',
            fullComponentLibrary: 'Partes de aspecto real',
            prioritySupport: 'Soporte Prioritario',
            helpWhenNeeded: 'Ayuda cuando la necesites',
            testimonial: 'Es agradable interactuar con él. La interfaz de usuario me da la sensación de operar una unidad de relé real en un laboratorio.',
            testimonialAuthor: 'Aficionado en Queensland',
            continueWithLimited: 'Continuar con Acceso Limitado',
            upgradeNow: '¡Empezar con {cheapest_plan}!',
            schoolLicenseMessage: 'Para seguir usando DCACLab, los estudiantes necesitan una licencia escolar. Por favor, pide a tu profesor que compre una para acceso ilimitado.'
        },
        tr: {
            upgradeExperience: 'Deneyiminizi Yükseltin',
            premiumBenefits: 'Avantajlar',
            unlimitedLabTime: 'Sınırsız Laboratuvar Süresi',
            noTimeRestrictions: 'Zaman kısıtlaması yok',
            saveUnlimitedCircuits: 'Deneyimlerinizi kaydedin',
            neverLoseWork: 'Çalışmalarınızı asla kaybetmeyin',
            allComponents: '40+ Bileşen',
            fullComponentLibrary: 'Gerçek görünümlü parçalar',
            prioritySupport: 'Öncelikli Destek',
            helpWhenNeeded: 'İhtiyacınız olduğunda yardım',
            testimonial: 'Onunla etkileşim kurmak keyifli. Kullanıcı arabirimi bana laboratuvarda gerçek bir röle birimi çalıştırdığım hissini veriyor.',
            testimonialAuthor: 'Queensland\'deki Hobi Meraklısı',
            continueWithLimited: 'Sınırlı Erişimle Devam Et',
            upgradeNow: '{cheapest_plan} ile başlayın!',
            schoolLicenseMessage: 'Öğrencilerden DCACLab\'u kullanmaya devam etmek için öğretmenleriyle okul lisansı alma konusunda görüşmelerini nazikce rica ediyoruz.'
        },
        th: {
            upgradeExperience: 'อัปเกรดประสบการณ์ของคุณ',
            premiumBenefits: 'สิทธิประโยชน์',
            unlimitedLabTime: 'เวลาห้องแล็บไม่จำกัด',
            noTimeRestrictions: 'ไม่มีข้อจำกัดด้านเวลา',
            saveUnlimitedCircuits: 'บันทึกการทดลองของคุณ',
            neverLoseWork: 'ไม่สูญเสียงานของคุณ',
            allComponents: '40+ ส่วนประกอบ',
            fullComponentLibrary: 'ชิ้นส่วนที่ดูจริง',
            prioritySupport: 'การสนับสนุนที่มีความสำคัญ',
            helpWhenNeeded: 'ช่วยเหลือเมื่อคุณต้องการ',
            testimonial: 'มันสนุกที่จะโต้ตอบด้วย อินเทอร์เฟซให้ความรู้สึกเหมือนการใช้งานหน่วยรีเลย์จริงในห้องแล็บ',
            testimonialAuthor: 'นักสะสมงานอดิเรกในควีนส์แลนด์',
            continueWithLimited: 'ดำเนินการต่อด้วยการเข้าถึงแบบจำกัด',
            upgradeNow: 'เริ่มต้นด้วย {cheapest_plan}!',
            schoolLicenseMessage: 'เราขอเรียนเชิญให้นักเรียนตรวจสอบกับครูผู้สอนของพวกเขาเกี่ยวกับการขอรับใบอนุญาตสำหรับโรงเรียนเพื่อใช้ DCACLab ต่อไป'
        },
        mx: {
            upgradeExperience: 'Mejora Tu Experiencia',
            premiumBenefits: 'Beneficios',
            unlimitedLabTime: 'Tiempo de Laboratorio Ilimitado',
            noTimeRestrictions: 'Sin restricciones de tiempo',
            saveUnlimitedCircuits: 'Guarda tus experimentos',
            neverLoseWork: 'Nunca pierdas tu trabajo',
            allComponents: '40+ Componentes',
            fullComponentLibrary: 'Partes de aspecto real',
            prioritySupport: 'Soporte Prioritario',
            helpWhenNeeded: 'Ayuda cuando la necesites',
            testimonial: 'Es agradable interactuar con él. La interfaz de usuario me da la sensación de operar una unidad de relé real en un laboratorio.',
            testimonialAuthor: 'Aficionado en Queensland',
            continueWithLimited: 'Continuar con Acceso Limitado',
            upgradeNow: '¡Empezar con {cheapest_plan}!',
            schoolLicenseMessage: 'Para seguir usando DCACLab, los estudiantes necesitan una licencia escolar. Por favor, pide a tu profesor que compre una para acceso ilimitado.'
        }
    };
    
    // Get the correct translations based on locale, fallback to English
    const t = translations[this.props.current_locale] || translations['en'];
    

        return this.state.isVisible ? (
            <Transition
                animation="shake"
                duration={1000}
                visible={this.props.limited}
                onStart={() => {
                    console.log('Transition shake started');
                    if (this.props.cta === null) {
                        console.log('CTA is null - triggering rainbow sweep');
                        this.startRainbowAnimation();
                        this.setState({ isShaking: true });
                    } else {
                        console.log('CTA is not null - no rainbow sweep');
                    }
                }}
                onComplete={() => {
                    console.log('Transition shake completed');
                    if (this.props.cta === null) {
                        console.log('Continuing rainbow sweep for 2 more seconds');
                        // Continue rainbow sweep for 2 more seconds after shake finishes
                        setTimeout(() => {
                            console.log('Stopping rainbow sweep');
                            this.setState({ isShaking: false });
                            this.stopRainbowAnimation();
                        }, 800);
                    }
                }}
            >
                <Segment
                    style={{
                        padding: 9,
                        marginLeft: marginLeft,
                        color: 'black',
                        background: '#ffefee',
                        width: 450,
                        left: 10,
                        position: 'fixed',
                        bottom: 7,
                        zIndex: 1000,
                        overflowX: 'hidden', // Hide horizontal scroll
                        overflowY: 'auto', // Keep vertical scroll if needed
                        maxHeight: 'calc(100vh - 20px)', // Maximum height relative to the viewport, with some space
                        maxWidth: 'calc(100vw - 40px)', // Prevent exceeding viewport width
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        boxSizing: 'border-box', // Include padding and border in width calculation
                    }}
                >
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                        <Header style={{
                            marginBottom: 0,
                            paddingRight: '40px',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none'
                        }} textAlign='center'>{this.props.cta?.title || l.demo_mode}</Header>
                        <Button
                            icon
                            basic
                            compact
                            onClick={() => {
                                this.setState({isVisible: false});
                                this.props.setLimitation(false);
                                this.props.setLimited(false);
                                }
                            }
                            style={{
                                position: 'absolute',
                                right: '-10px',
                                top: '-10px',
                                padding: 0,
                                margin: 0,
                                width: '30px',
                                height: '30px',
                                minHeight: '30px',
                                minWidth: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '4px'
                            }}
                        >
                            <Icon 
                                name='remove' 
                                style={{ 
                                    margin: 0, 
                                    padding: 0,
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '100%',
                                    position: 'relative',
                                    top: '1px',  // Adjust this value as needed
                                    left: '1px'  // Adjust this value as needed
                                }} 
                            />
                        </Button>
                        <hr style={{ width: '100%', borderTop: '1px solid #ccc', marginBottom: 15 }} /> {/* Separator line */}
                        <div style={{ 
                            fontSize: 'initial', 
                            paddingBottom: 15, 
                            textAlign: 'center',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none'
                        }}>
                            {messageBody ? 
                                <div dangerouslySetInnerHTML={{ __html: messageBody }} /> 
                                : <p>{l.limitation_message}</p>
                            }
                        </div>
                    </div>


                    <div style={{ 
                        position: 'relative', 
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        isolation: 'isolate'
                    }}>
                        <Button
                            id="action-message-button"
                            className={`${this.state.isShaking ? "rainbow-button" : ""} ${this.state.isShimmering ? "shimmer-effect" : ""}`.trim()}
                            style={this.state.isShaking ? {
                                fontSize: 'initial',
                                backgroundColor: this.rainbowColors[this.state.rainbowFrame],
                                color: '#ffffff',
                                textShadow: '1px 1px 2px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 0px 0px 3px rgba(0,0,0,0.9)',
                                fontWeight: 'bold',
                                border: '2px solid rgba(255,255,255,0.8)',
                                boxShadow: '0 0 15px rgba(255,255,255,0.6), inset 0 0 10px rgba(255,255,255,0.3)',
                                transition: 'all 0.05s ease',
                                minHeight: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            } : { 
                                fontSize: 'initial', 
                                backgroundColor: '#75b813', 
                                color: '#ffffff',
                                minHeight: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            onClick={() => window.open(this.props.cta?.url || "/pricing-table", '_blank')}
                            content={this.props.cta?.button_text || (this.props.cheapest_plan ? t.upgradeNow.replace('{cheapest_plan}', this.props.cheapest_plan) : 'Upgrade Now')}
                        />
                    </div>
                    {this.state.isShaking && <div style={{display: 'none'}}>RAINBOW ACTIVE - Frame: {this.state.rainbowFrame} - Color: {this.rainbowColors[this.state.rainbowFrame]}</div>}
                </Segment>
            </Transition>
        ) : <div></div>;
    }
}
